import { LIVE_SIGNED_OUT_CODE } from "@omnabase/shared";

/** The forum sync round (2026-11-02, finding 20): a live socket closed with the server's 4401 ("your session ended") asks whether the person
 *  is still signed in (the signed-out sheet's check); the reconnect itself follows shared's `liveReconnectDelay`, which never reconnects after
 *  4401. Pure, so the rule is tested without a socket. */
export const checksSession = (code: number): boolean => code === LIVE_SIGNED_OUT_CODE;
